import React from 'react';
import Context from '../../assets/js/Context';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import { Row, Col, Card, Form, Alert, Container } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Component from "@reactions/component";
import { SideSheet, Position, Pane, Dialog, Button } from 'evergreen-ui';
import { ToastContainer, toast } from 'react-toastify';
import SearchIcon from '@material-ui/icons/Search';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteForeverIcon from '@material-ui/icons/Delete';
import AddBusiness from '@material-ui/icons/DoneAll';
import PrintIcon from '@material-ui/icons/Print';
import DevicesIcon from '@material-ui/icons/DevicesOther';
import ListAltIcon from '@material-ui/icons/ListAlt';
import PersonIcon from '@material-ui/icons/Person';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import LockIcon from '@material-ui/icons/Lock';
import 'react-toastify/dist/ReactToastify.css';
import * as moment from "moment-timezone";
import Login from '../common/login';
import ReactToPrint from 'react-to-print-advanced';
import { Link } from 'react-router-dom';
import qs from 'qs';

// Styled Components
const styles = {
  mainContainer: {
    minHeight: '100vh',
    backgroundColor: '#f5f7fa',
    paddingTop: '20px',
    direction: 'rtl'
  },
  headerSection: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    borderRadius: '20px',
    padding: '30px',
    margin: '0 20px 30px 20px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
    direction: 'rtl'
  },
  searchBar: {
    backgroundColor: 'white',
    borderRadius: '50px',
    padding: '10px 20px',
    boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
    display: 'flex',
    alignItems: 'center',
    maxWidth: '500px',
    margin: '0 auto',
    direction: 'rtl',
    flexDirection: 'row'
  },
  searchInput: {
    border: 'none',
    outline: 'none',
    flex: 1,
    fontSize: '16px',
    padding: '10px',
    borderRadius: '50px',
    direction: 'rtl',
    textAlign: 'right'
  },
  searchButton: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    border: 'none',
    borderRadius: '50px',
    padding: '10px 30px',
    color: 'white',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'transform 0.2s',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginLeft: '10px',
    flexDirection: 'row-reverse'
  },
  statsCard: {
    backgroundColor: 'white',
    borderRadius: '20px',
    padding: '25px',
    margin: '0 20px 30px 20px',
    boxShadow: '0 5px 20px rgba(0,0,0,0.08)',
    transition: 'transform 0.3s, box-shadow 0.3s',
    direction: 'rtl'
  },
  statItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 0',
    borderBottom: '1px solid #f0f0f0',
    flexDirection: 'row-reverse'
  },
  statIcon: {
    width: '45px',
    height: '45px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '10px'
  },
  tableContainer: {
    backgroundColor: 'white',
    borderRadius: '20px',
    padding: '25px',
    margin: '0 20px 30px 20px',
    boxShadow: '0 5px 20px rgba(0,0,0,0.08)',
    overflowX: 'auto',
    direction: 'rtl'
  },
  modernTable: {
    width: '100%',
    borderCollapse: 'separate',
    borderSpacing: '0',
    fontSize: '16px',
    direction: 'rtl'
  },
  tableHeader: {
    backgroundColor: '#f8f9fc',
    color: '#5a5c69',
    fontWeight: '600',
    padding: '15px',
    textAlign: 'center',
    borderBottom: '2px solid #e3e6f0'
  },
  tableCell: {
    padding: '15px',
    textAlign: 'center',
    borderBottom: '1px solid #e3e6f0',
    color: '#5a5c69'
  },
  actionButton: {
    backgroundColor: '#667eea',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    padding: '12px 30px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'all 0.3s',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    margin: '10px',
    flexDirection: 'row-reverse'
  },
  deleteButton: {
    backgroundColor: '#ff4757',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s'
  },
  summarySection: {
    backgroundColor: 'white',
    borderRadius: '20px',
    padding: '25px',
    margin: '0 20px 30px 20px',
    boxShadow: '0 5px 20px rgba(0,0,0,0.08)',
    direction: 'rtl'
  },
  summaryHeader: {
    background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    color: 'white',
    padding: '15px',
    borderRadius: '15px',
    textAlign: 'center',
    fontSize: '20px',
    fontWeight: 'bold',
    marginBottom: '20px'
  }
};

const cookies = new Cookies();
let id = 0;

class Selles_Reports extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            from: new Date(),
            to: new Date(),
            spin: false,
            serch: false,
            total: '',
            total_items: 0,
            total_orders: 0,
            items_cost: 0,
            orders_cost: 0,
            ordes2: [],
            items: [],
            id: '',
            cash: '',
            cash_orders: '',
            total_price: "",
            t_safee: 0,
            createdAt: '',
            selectedItems: [{}, {}],
            name: "",
            count: 0,
            listDev: [],
            check: false,
            itemsOut: [],
        }
        const urlParams = new URLSearchParams(window.location.search);
        let Getid = urlParams.get('id')
        let type = urlParams.get('type')
        this.setState({ id: Getid, type })
        this.Orders(Getid)
        id = Getid
    }

    componentDidMount() {
        let header = { "Content-Type": "application/json", token: cookies.get("token") };
        axios.get(host + `dashbord/shiper/all/`, { headers: header })
            .then(res => {
                this.setState({ shiper: res.data.shiper })
            })
            .catch(error => {
                console.log(error.response)
            });

        const urlParams = new URLSearchParams(window.location.search);
        let Getid = urlParams.get('id')
        let type = urlParams.get('type')
        this.setState({ id: Getid, type })
        this.Orders(Getid)
        id = Getid
    }

    Orders(id) {
        axios.get(host + `dashbord/sanaToInList/list/${id}`)
            .then(res => {
                let arr = [];
                let list = res.data.list.dev

                for (let index = 0; index < list.length; index++) {
                    let obj = {
                        id: list[index].id,
                        phone_id: list[index].phone.id,
                        item_out: list[index].phone.item_out.name,
                        item_in: list[index].phone.item_in.name,
                        paybass: list[index].phone.paybass,
                        list: list[index].phone.list.id,
                        name: list[index].phone.admin.name,
                    }
                    arr.push(obj)
                }

                this.setState({
                    listDev: arr,
                    createdAt: moment(res.data.list.createdAt).format('YYYY-MM-DD'),
                    count: arr.length,
                    name: res.data.list.admin,
                    check: res.data.list.is_checked,
                    itemsOut: res.data.items_out_g
                })
            })
            .catch(error => {
                console.log(error.response)
            });
    }

    add(value) {
        if (this.state.check) {
            toast.error("لا يمكن الإضافة - القائمة مؤكدة", {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
            return;
        }
        
        axios.post(host + `dashbord/sanaToInList/add/`,
            qs.stringify({
                list_id: id,
                phone_id: value,
            }), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token")
            }
        })
            .then(response => {
                this.Orders(id)
                document.getElementById('orderFiled').value = ''
                toast.success('تمت الاضافة بنجاح', {
                    position: "bottom-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                });
            })
            .catch(error => {
                console.log(error.message);
                toast.error("حصل خطأ تأكد من المعلومات", {
                    position: "bottom-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                });
                console.log(error)
                this.setState({ spinerBtn: false })
            })
    }

    render() {
        if (cookies.get("token")) {
            return (
                <Context.Consumer>
                    {ctx => {
                        return (
                            <div style={styles.mainContainer} dir="rtl">
                                {/* Header Section */}
                                <div style={styles.headerSection}>
                                    {this.state.check && (
                                        <Alert variant="warning" style={{ marginBottom: '20px', textAlign: 'center' }}>
                                            <strong>تنبيه:</strong> هذه القائمة مؤكدة ولا يمكن إضافة أجهزة جديدة إليها
                                        </Alert>
                                    )}
                                    <div style={styles.searchBar}>
                                        <input
                                            style={{
                                                ...styles.searchInput,
                                                ...(this.state.check ? { 
                                                    backgroundColor: '#f5f5f5',
                                                    cursor: 'not-allowed'
                                                } : {})
                                            }}
                                            id="orderFiled"
                                            type="text"
                                            placeholder={this.state.check ? "القائمة مؤكدة - لا يمكن الإضافة" : "ادخل رقم الجهاز..."}
                                            disabled={this.state.check}
                                            onKeyPress={(e) => {
                                                if (e.key === "Enter" && !this.state.check) {
                                                    if (e.target.value) {
                                                        this.add(document.getElementById('orderFiled').value)
                                                    }
                                                }
                                            }}
                                        />
                                        <button
                                            style={{
                                                ...styles.searchButton,
                                                ...(this.state.check ? { 
                                                    backgroundColor: '#ccc', 
                                                    background: '#ccc',
                                                    cursor: 'not-allowed',
                                                    opacity: 0.6
                                                } : {})
                                            }}
                                            onClick={() => {
                                                if (!this.state.check) {
                                                    let order_id = document.getElementById('orderFiled').value
                                                    this.add(order_id)
                                                }
                                            }}
                                            onMouseOver={(e) => {
                                                if (!this.state.check) {
                                                    e.target.style.transform = 'scale(1.05)'
                                                }
                                            }}
                                            onMouseOut={(e) => {
                                                if (!this.state.check) {
                                                    e.target.style.transform = 'scale(1)'
                                                }
                                            }}
                                            disabled={this.state.check}
                                        >
                                            إضافة <AddCircleIcon />
                                        </button>
                                    </div>
                                </div>

                                {/* Stats Cards */}
                                <div style={styles.statsCard}>
                                    <Row>
                                        <Col md={2} xs={12} className="mb-3">
                                            <div style={styles.statItem}>
                                                <div>
                                                    <h6 style={{ color: '#858796', marginBottom: '3px', textAlign: 'right', fontSize: '14px' }}>حالة القائمة</h6>
                                                    <h4 style={{ 
                                                        color: this.state.check ? '#e74a3b' : '#1cc88a', 
                                                        fontWeight: 'bold', 
                                                        textAlign: 'right',
                                                        fontSize: '20px'
                                                    }}>
                                                        {this.state.check ? 'مؤكدة' : 'مفتوحة'}
                                                    </h4>
                                                </div>
                                                <div style={{ 
                                                    ...styles.statIcon, 
                                                    backgroundColor: this.state.check ? '#e74a3b20' : '#1cc88a20' 
                                                }}>
                                                    {this.state.check ? 
                                                        <LockIcon style={{ color: '#e74a3b', fontSize: '22px' }} /> :
                                                        <CheckCircleIcon style={{ color: '#1cc88a', fontSize: '22px' }} />
                                                    }
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={2} xs={12} className="mb-3">
                                            <div style={styles.statItem}>
                                                <div>
                                                    <h6 style={{ color: '#858796', marginBottom: '3px', textAlign: 'right', fontSize: '14px' }}>رقم القائمة</h6>
                                                    <h4 style={{ color: '#5a5c69', fontWeight: 'bold', textAlign: 'right', fontSize: '20px' }}>{id}</h4>
                                                </div>
                                                <div style={{ ...styles.statIcon, backgroundColor: '#4e73df20' }}>
                                                    <ListAltIcon style={{ color: '#4e73df', fontSize: '22px' }} />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={3} xs={12} className="mb-3">
                                            <div style={styles.statItem}>
                                                <div>
                                                    <h6 style={{ color: '#858796', marginBottom: '3px', textAlign: 'right', fontSize: '14px' }}>عدد الأجهزة</h6>
                                                    <h4 style={{ color: '#5a5c69', fontWeight: 'bold', textAlign: 'right', fontSize: '20px' }}>{this.state.count}</h4>
                                                </div>
                                                <div style={{ ...styles.statIcon, backgroundColor: '#1cc88a20' }}>
                                                    <DevicesIcon style={{ color: '#1cc88a', fontSize: '22px' }} />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={3} xs={12} className="mb-3">
                                            <div style={styles.statItem}>
                                                <div>
                                                    <h6 style={{ color: '#858796', marginBottom: '3px', textAlign: 'right', fontSize: '14px' }}>المحاسب</h6>
                                                    <h4 style={{ color: '#5a5c69', fontWeight: 'bold', textAlign: 'right', fontSize: '20px' }}>{this.state.name}</h4>
                                                </div>
                                                <div style={{ ...styles.statIcon, backgroundColor: '#f6c23e20' }}>
                                                    <PersonIcon style={{ color: '#f6c23e', fontSize: '22px' }} />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={2} xs={12} className="mb-3">
                                            <div style={styles.statItem}>
                                                <div>
                                                    <h6 style={{ color: '#858796', marginBottom: '3px', textAlign: 'right', fontSize: '14px' }}>التاريخ</h6>
                                                    <h4 style={{ color: '#5a5c69', fontWeight: 'bold', textAlign: 'right', fontSize: '20px' }}>{this.state.createdAt}</h4>
                                                </div>
                                                <div style={{ ...styles.statIcon, backgroundColor: '#36b9cc20' }}>
                                                    <CalendarTodayIcon style={{ color: '#36b9cc', fontSize: '22px' }} />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>

                                {/* Action Buttons */}
                                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                                    <ReactToPrint
                                        content={() => this.PrintComp}
                                        trigger={() => (
                                            <button 
                                                style={styles.actionButton}
                                                onMouseOver={(e) => e.target.style.backgroundColor = '#5a5fc9'}
                                                onMouseOut={(e) => e.target.style.backgroundColor = '#667eea'}
                                            >
                                                طباعة كشف <PrintIcon />
                                            </button>
                                        )}
                                    />
                                    
                                    {!this.state.check && (
                                        <Component initialState={{ isShown: false, logding: false }}>
                                            {({ state, setState }) => (
                                                <Pane>
                                                    <Dialog
                                                        isShown={state.isShown}
                                                        title={`ادخال مخزني`}
                                                        intent="danger"
                                                        isConfirmLoading={state.logding}
                                                        onCloseComplete={() => setState({ isShown: false })}
                                                        confirmLabel="تأكيد"
                                                        cancelLabel="الغاء"
                                                        onConfirm={() => {
                                                            setState({ logding: true })
                                                            const urlParams = new URLSearchParams(window.location.search);
                                                            let Getid = urlParams.get('id')

                                                            axios.post(host + `dashbord/sanaToInList/sendToInv/${Getid}`, {
                                                                headers: {
                                                                    "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token")
                                                                }
                                                            })
                                                                .then(response => {
                                                                    this.Orders(id)
                                                                    setState({ isShown: false, logding: false })
                                                                    toast.success('تم ادخال القائمة الى المخزن بنجاح', {
                                                                        position: "bottom-center",
                                                                        autoClose: 5000,
                                                                        hideProgressBar: false,
                                                                        closeOnClick: true,
                                                                        pauseOnHover: true,
                                                                        draggable: true
                                                                    });
                                                                })
                                                                .catch(error => {
                                                                    this.Orders(id)
                                                                    setState({ logding: false })
                                                                    toast.error("حصل خطأ تأكد من المعلومات", {
                                                                        position: "bottom-center",
                                                                        autoClose: 5000,
                                                                        hideProgressBar: false,
                                                                        closeOnClick: true,
                                                                        pauseOnHover: true,
                                                                        draggable: true
                                                                    });
                                                                    console.log(error)
                                                                })
                                                        }}
                                                    >
                                                        <span id='msgDelete'> هل متأكد ادخال القائمة الى المخزن ؟ </span>
                                                    </Dialog>
                                                    <button 
                                                        style={{ ...styles.actionButton, backgroundColor: '#1cc88a' }}
                                                        onClick={() => setState({ isShown: true })}
                                                        onMouseOver={(e) => e.target.style.backgroundColor = '#17a673'}
                                                        onMouseOut={(e) => e.target.style.backgroundColor = '#1cc88a'}
                                                    >
                                                        ادخال الى المخزن <AddBusiness />
                                                    </button>
                                                </Pane>
                                            )}
                                        </Component>
                                    )}
                                </div>

                                {/* Devices Table */}
                                <div style={styles.tableContainer}>
                                    <table style={styles.modernTable}>
                                        <thead>
                                            <tr>
                                                <th style={styles.tableHeader}>رقم الجهاز</th>
                                                <th style={styles.tableHeader}>اسم الموظف</th>
                                                <th style={styles.tableHeader}>الجهاز الأولى</th>
                                                <th style={styles.tableHeader}>الجهاز النهائي</th>
                                                <th style={styles.tableHeader}>رقم القائمة</th>
                                                {!this.state.check && <th style={styles.tableHeader}>حذف</th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.listDev.map((order, i) => (
                                                <tr key={i} style={{ transition: 'background-color 0.3s' }}
                                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f8f9fc'}
                                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
                                                    <td style={styles.tableCell}>{order.phone_id}</td>
                                                    <td style={styles.tableCell}>{order.name}</td>
                                                    <td style={styles.tableCell}>{order.item_in}</td>
                                                    <td style={styles.tableCell}>{order.item_out}</td>
                                                    <td style={styles.tableCell}>
                                                        <Link to={`/SanaBill?id=${order.list}`} 
                                                            style={{ color: '#667eea', textDecoration: 'none', fontWeight: 'bold' }}>
                                                            {order.list}
                                                        </Link>
                                                    </td>
                                                    {!this.state.check && (
                                                        <td style={styles.tableCell}>
                                                            <Component initialState={{ isShown: false, isConfirmLoading: false }}>
                                                                {({ state, setState }) => (
                                                                    <Pane>
                                                                        <Dialog
                                                                            isShown={state.isShown}
                                                                            title='حذف'
                                                                            onCloseComplete={() => setState({ isShown: false })}
                                                                            confirmLabel="حذف"
                                                                            cancelLabel="الغاء"
                                                                            isConfirmLoading={state.isConfirmLoading}
                                                                            onConfirm={() => {
                                                                                setState({ isConfirmLoading: true })
                                                                                axios.delete(host + `dashbord/sanaToInList/${order.id}`, {
                                                                                    headers: {
                                                                                        "Content-Type": "application/x-www-form-urlencoded", 
                                                                                        token: cookies.get("token")
                                                                                    }
                                                                                })
                                                                                    .then(response => {
                                                                                        this.Orders(id)
                                                                                        toast.success('ازلة الجهاز من القائمة بنجاح', {
                                                                                            position: "bottom-center",
                                                                                            autoClose: 5000,
                                                                                            hideProgressBar: false,
                                                                                            closeOnClick: true,
                                                                                            pauseOnHover: true,
                                                                                            draggable: true
                                                                                        });
                                                                                        setState({ isShown: false })
                                                                                    })
                                                                                    .catch(error => {
                                                                                        setState({ isConfirmLoading: false })
                                                                                        toast.error("حصل خطأ تأكد من المعلومات", {
                                                                                            position: "bottom-center",
                                                                                            autoClose: 5000,
                                                                                            hideProgressBar: false,
                                                                                            closeOnClick: true,
                                                                                            pauseOnHover: true,
                                                                                            draggable: true
                                                                                        });
                                                                                        console.log(error)
                                                                                    })
                                                                            }}
                                                                        >
                                                                            <Alert variant="danger">
                                                                                هل تريد فعلا حذف هذا الجهاز؟
                                                                            </Alert>
                                                                        </Dialog>
                                                                        <button 
                                                                            style={styles.deleteButton}
                                                                            onClick={() => setState({ isShown: true })}
                                                                            onMouseOver={(e) => {
                                                                                e.target.style.backgroundColor = '#ee5a6f'
                                                                                e.target.style.transform = 'scale(1.1)'
                                                                            }}
                                                                            onMouseOut={(e) => {
                                                                                e.target.style.backgroundColor = '#ff4757'
                                                                                e.target.style.transform = 'scale(1)'
                                                                            }}
                                                                        >
                                                                            <DeleteForeverIcon />
                                                                        </button>
                                                                    </Pane>
                                                                )}
                                                            </Component>
                                                        </td>
                                                    )}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Summary Section */}
                                <div style={styles.summarySection}>
                                    <div style={styles.summaryHeader}>
                                        ملخص الأجهزة
                                    </div>
                                    <table style={styles.modernTable} ref={(refer) => (this.PrintComp = refer)}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...styles.tableHeader, backgroundColor: '#e3f2fd' }}>اسم الجهاز</th>
                                                <th style={{ ...styles.tableHeader, backgroundColor: '#e3f2fd' }}>العدد</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.itemsOut.map((order, i) => (
                                                <tr key={i}>
                                                    <td style={styles.tableCell}>{order.name}</td>
                                                    <td style={styles.tableCell}>
                                                        <span style={{
                                                            backgroundColor: '#667eea',
                                                            color: 'white',
                                                            padding: '5px 15px',
                                                            borderRadius: '20px',
                                                            fontWeight: 'bold'
                                                        }}>
                                                            {order.count}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <ToastContainer
                                    position="bottom-left"
                                    autoClose={10000}
                                    hideProgressBar={false}
                                    newestOnTop={false}
                                    closeOnClick
                                    rtl={true}
                                    pauseOnVisibilityChange
                                    draggable
                                    pauseOnHover
                                />
                            </div>
                        )
                    }}
                </Context.Consumer>
            )
        }
        else {
            return <Login />
        }
    }
}

export default Selles_Reports;